window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

var _ = require('lodash');

import { createApp } from 'vue'
import { createStore, createLogger } from 'vuex'
import PrimeVue from 'primevue/config'
import OverlayPanel from 'primevue/overlaypanel';
import LazyLoad from 'vanilla-lazyload'

import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollToPlugin);
gsap.registerPlugin(ScrollTrigger)

const debug = process.env.NODE_ENV !== 'production'

const store = createStore({
	state() {
		return {
			openMenu: false,
			isLarge: '',
			isMedium: '',
			width: '',
			height: '',
		}
	},

	getters: {
		isLarge(state) {
			return state.isLarge
		},
		isMedium(state) {
			return state.isMedium
		},
		width(state) {
			return state.width
		},
		height(state) {
			return state.height
		}
	},

	mutations: {
		toggleMenu(state) {
			state.openMenu = !state.openMenu
		},
		setLarge(state, payload) {
			state.isLarge = payload
		},
		setMedium(state, payload) {
			state.isMedium = payload
		},
		setWidth(state, payload) {
			state.width = payload
		},
		setHeight(state, payload) {
			state.height = payload
		},
	},

	actions: {
		breakpoint(context) {
			context.commit('setMedium', window.matchMedia('(min-width: 45em)').matches)
			context.commit('setLarge', window.matchMedia('(min-width: 80em)').matches)
			context.commit('setWidth', window.innerWidth)
			context.commit('setHeight', window.innerHeight)
		}
	},
	plugins: debug ? [createLogger()] : [],
})

const app = createApp({
	methods: {
		toggleLocales(event) {
			this.$refs.locales.toggle(event);
		},
	}
})

app.component('FullscreenMenu', require('./components/FullscreenMenu.vue').default)
app.component('Newsletter', require('./components/Newsletter.vue').default)
app.component('News', require('./components/News/News.vue').default)
app.component('Businesses', require('./components/Businesses/Businesses.vue').default)
app.component('NewsSlider', require('./components/News/NewsSlider.vue').default)
app.component('ModalWithButton', require('./components/ModalWithButton.vue').default)
app.component('DropdownMenu', require('./components/DropdownMenu.vue').default)
app.component('ImageSlider', require('./components/ImageSlider.vue').default)
app.component('FormComponent', require('./components/Forms/FormComponent.vue').default)
app.component('GoogleMap', require('./components/GoogleMap.vue').default)
app.component('GoogleMapBusiness', require('./components/GoogleMapBusiness.vue').default)
app.component('overlaypanel', OverlayPanel)

app.use(store)
app.use(PrimeVue)
store.dispatch('breakpoint')

app.mount('#app')

// 100% height on mobile
const appHeight = () => {
    const doc = document.documentElement
    doc.style.setProperty('--app-height', `${window.innerHeight}px`)
}
window.addEventListener('resize', appHeight)
appHeight()

// Smooth scroll
const scrollTos = document.querySelectorAll(".scroll-to");
	
for (const scrollTo of scrollTos) {
	scrollTo.addEventListener("click", scrollHandler);
}
	
function scrollHandler(e) {
	const target = this.dataset.scroll;
	const offset = parseInt(window.getComputedStyle(document.querySelector(target)).getPropertyValue('margin-top'));
	gsap.to(window, {duration: 1, scrollTo: {y: target, offsetY: offset}});
}

var getElemDistance = function ( elem ) {
    var location = 0;
    if (elem.offsetParent) {
        do {
            location += elem.offsetTop;
            elem = elem.offsetParent;
        } while (elem);
    }
    return location >= 0 ? location : 0;
};

if (document.querySelector('.header-text')) {
	if (getElemDistance(document.querySelector('.header-text')) < document.querySelector('.logo-container').offsetHeight) {
		document.querySelector('.header-container').classList.remove('md:items-center')
		document.querySelector('.header-container').classList.add(...['md:items-end', 'justify-center'])
		document.querySelector('.header-text').classList.remove('md:mb-0')
		document.querySelector('.header-text').classList.add('md:mb-12')
	}
}

document.querySelectorAll(".bard-text a").forEach((el) => {
	const text = el.textContent
	const span = document.createElement('span')
	span.appendChild(document.createTextNode(text))
	el.innerHTML = span.outerHTML
})

if (document.getElementById('home-header') || document.getElementById('page-header')) {
	document.tl = gsap.timeline({
		delay: 0.5,
		immediateRender: true,
		defaults: { 
			duration: 0.60,
		}
	}) 
	document.tl	    
	    .fromTo('.logo-container', {yPercent: '-100', autoAlpha: 0}, {yPercent: 0, autoAlpha: 1})
	    .fromTo('.logo', {y: '-20px', autoAlpha: 0}, {y: 0, autoAlpha: 1})
	    .fromTo('#menu-button', {y: '-20px', autoAlpha: 0}, {y: 0, autoAlpha: 1})
		.fromTo('.menu-container', {yPercent: '-100', autoAlpha: 0}, {yPercent: 0, autoAlpha: 1}, "-=0.5")

		if (document.getElementById('page-header')) {
			document.tl		
			.fromTo('.header-text', {x: '-20px', autoAlpha: 0}, {x: 0, autoAlpha: 1})
			.fromTo('.overtitle', {x: '-20px', autoAlpha: 0}, {x: 0, autoAlpha: 1}, "-=0.25")
			.fromTo('.slogan', {x: '-20px', autoAlpha: 0}, {x: 0, autoAlpha: 1}, "-=0.25")
			.fromTo('.scroll-to', {y: '-20px', autoAlpha: 0}, {y: 0, autoAlpha: 1})
		}

		if (document.getElementById('home-header')) {
			document.tl
			.fromTo('.overtitle', {x: '-20px', autoAlpha: 0}, {x: 0, autoAlpha: 1})
			.fromTo('.slogan', {x: '-20px', autoAlpha: 0}, {x: 0, autoAlpha: 1}, "-=0.25")
			.fromTo('.scroll-to', {y: '-20px', autoAlpha: 0}, {y: 0, autoAlpha: 1})
			.fromTo('.links a', {x: '-20px', autoAlpha: 0}, {x: 0, autoAlpha: 1, stagger: 0.2}, "-=0.25")			
			.fromTo('.weather', {autoAlpha: 0}, {autoAlpha: 1})	
			.fromTo('.gobacksafe', {autoAlpha: 0}, {autoAlpha: 1})	
		}
			
}

if (document.getElementById('intro')) {
	let intro = gsap.timeline({
		immediateRender: true,
		defaults: { 
			duration: 1,
		},
		scrollTrigger: {
			trigger: '#intro',
			start: 'top 80%',
			end: 'bottom',
		}		
	})

	intro
	.fromTo('#intro .blue-bg-container', {xPercent: ' -100', visibility: 'visible'}, {xPercent: '100'}, "start")
	.fromTo('#intro .gray-bg-container', {xPercent: '-100'}, {xPercent: 0}, "start")
	.fromTo('.intro-slogan', {y: '40px', autoAlpha: 0}, {y: '0', autoAlpha: 1}, "start+=1")
	.fromTo('.intro-paragraph', {y: '40px', autoAlpha: 0}, {y: '0', autoAlpha: 1}, "start+=1.5")
	.fromTo('.intro-image', {xPercent: '-100', autoAlpha: 0}, {xPercent: '0', autoAlpha: 1}, "start+=1")		

	let buttons = gsap.timeline({
		immediateRender: true,
		defaults: { 
			duration: 1,
		},
		scrollTrigger: {
			trigger: '.intro-features-title',
			start: 'top 80%',
			end: 'bottom',
		}		
	})

	buttons
		.fromTo('.intro-features-title', {x: '-20px', autoAlpha: 0}, {x: '0', autoAlpha: 1},)
		.fromTo('.intro-features-item', {x: '-20px', autoAlpha: 0}, {x: '0', autoAlpha: 1}, "-=0.5")
		.fromTo('.intro-features-buttons > div', {x: '-20px', autoAlpha: 0}, {x: '0', autoAlpha: 1}, "-=1")
}

if (document.querySelector(".text-with-image-layout")) {
	document.querySelectorAll(".text-with-image-layout").forEach((item) => {
		let tl = gsap.timeline({
			immediateRender: true,
			defaults: { 
				duration: 1,
			},
			scrollTrigger: {
				trigger: item,
				start: 'top 80%',
				end: 'bottom',
			}		
		})
		if (item.querySelector('.bg-container').classList.contains('left-0')) {
			tl.fromTo(item.querySelector('.blue-bg-container'), {xPercent: ' -100', visibility: 'visible'}, {xPercent: '100'})
			.fromTo(item.querySelector('.gray-bg-container'), {xPercent: '-100'}, {xPercent: 0}, "-=1")
			.fromTo(item.querySelector('.bard-text'), {x: ' -30px', autoAlpha: 0}, {x: 0, autoAlpha: 1}, "-=0.5")
			.fromTo(item.querySelector('.image-container'), {x: ' 30px', autoAlpha: 0}, {x: 0, autoAlpha: 1}, "-=0.5")
		}
		if (item.querySelector('.bg-container').classList.contains('right-0')) {
			tl.fromTo(item.querySelector('.blue-bg-container'), {xPercent: '100', visibility: 'visible'}, {xPercent: '-100'})
			.fromTo(item.querySelector('.gray-bg-container'), {xPercent: '100'}, {xPercent: 0}, "-=1")
			.fromTo(item.querySelector('.bard-text'), {x: ' 30px', autoAlpha: 0}, {x: 0, autoAlpha: 1})
			.fromTo(item.querySelector('.image-container'), {x: ' -30px', autoAlpha: 0}, {x: 0, autoAlpha: 1}, "-=0.5")
		}
	})    
}

if (document.querySelector(".list-with-description")) {
		let tl = gsap.timeline({
			immediateRender: true,
			defaults: { 
				duration: 1,
			},
			scrollTrigger: {
				trigger: '.list-with-description',
				start: 'top 80%',
				end: 'bottom',
			}		
		})
		tl.fromTo('.object-list', {x: ' -30px', autoAlpha: 0}, {x: 0, autoAlpha: 1}, "start")
		.fromTo('.list-with-description .waves', {x: ' 30px', autoAlpha: 0}, {x: ' -10px', autoAlpha: 1}, "start+=0.5")
		.fromTo('.slogan-list', {x: ' 30px', autoAlpha: 0}, {x: ' -10px', autoAlpha: 1}, "start+=1")
		.fromTo('.list-with-description .bard-text', {x: ' 30px', autoAlpha: 0}, {x: 0, autoAlpha: 1}, "start+=1.25")
		
}

if (!document.lazyLoadInstance) {
    document.lazyLoadInstance = new LazyLoad({
		callback_loaded: () => {
			if (document.tl) {
				document.tl.resume()
			}
		}
	});
}
